let choicesPromise = null;

const loadChoices = () => {
  if (!choicesPromise) {
    choicesPromise = import(/* webpackChunkName: "choices" */ 'choices.js')
      .then((module) => module.default || module);
  }

  return choicesPromise;
};

const initChoices = async (elements = document.querySelectorAll('.js-choice')) => {
  if (!elements.length) {
    return;
  }

  const Choices = await loadChoices();

  [...elements].forEach((element) => {
    element.choicesInstance?.destroy();
    element.choicesInstance = new Choices(element, {
      itemSelectText: '',
      fuseOptions: {
        includeScore: true,
        threshold: 0.5,
      },
    });
  });
};

export { initChoices, loadChoices };
